export default {"src":"/_next/static/image/public/images/new-logo.c59f518b795ca0e119fefbe5dfcb4c60.svg","height":24,"width":140};